import React from 'react';
import { InjectedRouter } from 'react-router';

import CoachingCoordinatorView from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorView';
import CoachingConstants from 'coaching/CoachingConstants';
import CurrentUser from 'auth/CurrentUser';
import GetCoachesContainer from 'coaching/containers/GetCoachesContainer';
import GetParticipantsContainer from 'coaching/containers/GetParticipantsContainer';
import { debounce } from 'lodash';

type Props = {
  router: InjectedRouter;
};

type State = {
  // The contents of the search input component
  nameSearchInputText: string;
  // The text that's being currently searched for
  nameQuery: string;
};

export default class CoachingCoordinatorContainer extends React.Component<Props, State> {
  state: State = {
    nameQuery: '',
    nameSearchInputText: '',
  };

  searchByName = debounce(
    () => {
      this.setState({
        nameQuery: this.state.nameSearchInputText.trim(),
      });
    },
    400,
    { trailing: true }
  );

  nameQueryChanged = (newQuery: string) => {
    this.setState(
      {
        nameSearchInputText: newQuery,
      },
      this.searchByName
    );
  };

  render() {
    const user = CurrentUser.isSignedIn() && CurrentUser.getUser();
    if (!user.hasFeature('coaching_coordinator.web.may-20')) {
      this.props.router.push(CoachingConstants.DEFAULT_SIGNED_IN_ROUTE);
      return null;
    }
    return (
      <GetCoachesContainer query={this.state.nameQuery}>
        {({
          coaches,
          endCursor: coachEndCursor,
          error,
          hasNextPage: coachListHasNextPage,
          loading: loadingCoaches,
          onNextPage: onNextCoachPage,
        }) => {
          const coachesErrorMessage = error?.message;
          return (
            <GetParticipantsContainer query={this.state.nameQuery}>
              {({
                endCursor: participantEndCursor,
                error,
                hasNextPage: participantListHasNextPage,
                loading: loadingParticipantsAndCancellations,
                onNextPage: onNextParticipantPage,
                participants,
              }) => {
                const participantsOrCancellationsErrorMessage = error?.message;
                return (
                  <CoachingCoordinatorView
                    loadingParticipants={loadingParticipantsAndCancellations}
                    loadingCoaches={loadingCoaches}
                    participantsError={participantsOrCancellationsErrorMessage}
                    coachesError={coachesErrorMessage}
                    participants={participants}
                    coaches={coaches}
                    participantPagination={{
                      onNextPage: () => onNextParticipantPage(participantEndCursor),
                      hasNextPage: participantListHasNextPage,
                    }}
                    coachPagination={{
                      onNextPage: () => onNextCoachPage(coachEndCursor),
                      hasNextPage: coachListHasNextPage,
                    }}
                    onNameQueryChanged={(newText: string) => {
                      this.nameQueryChanged(newText);
                    }}
                    nameQuery={this.state.nameSearchInputText}
                  />
                );
              }}
            </GetParticipantsContainer>
          );
        }}
      </GetCoachesContainer>
    );
  }
}
